import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select';
import CopyrightIcon from '@mui/icons-material/Copyright';
import CircularProgress from '@mui/material/CircularProgress';
import AsyncSelect from 'react-select/async';

function Stock() {
    const [dataBill, setDataBill] = useState([]);
    const [dataItem, setDataItem] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [selectedOption, setSelectedOption] = useState('itemWise');
    const [customerOptions, setCustomerOptions] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [customerId, setCustomer] = useState('0');
    const { isAuthenticated, companyId, branchId, permissions, token, username, logout } = useAuth();
    const [totalopbal, setTotalopbal] = useState(0);
    const [totalp, setTotalp] = useState(0);
    const [totalprtn, setTotalprtn] = useState(0);
    const [totals, setTotals] = useState(0);
    const [totalsrtn, setTotalsrtn] = useState(0);
    const [totalstin, setTotalsint] = useState(0);
    const [totalstout, setTotalstout] = useState(0);
    const [totalrpl, setTotalrpl] = useState(0);
    const [totalcls, setTotalcls] = useState(0);
    const [totalstkval, setTotalstkval] = useState(0);
    const [totalsalval, setTotalsalval] = useState(0);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        fetchTableData();
        fetchCustomerData();
    }, [isAuthenticated, companyId, branchId, token, username, logout]);

    useEffect(() => {
        // Calculate total 
        let totalopbal = 0;
        let totalp = 0;
        let totalprtn = 0;
        let totals = 0;
        let totalsrtn = 0;
        let totalstin = 0;
        // let totalstout = 0;
        let totalrpl = 0;
        let totalcls = 0;
        let totalstkval = 0;
        let totalsalval = 0;


        dataItem.forEach(item => {
            totalopbal += item.OpeningQty;
            totalp += item.PurchaseQty;
            totalprtn += item.PurchaseReturnQty;
            totals += item.SaleQty;
            totalsrtn += item.SaleReturnQty;
            totalstin += item.StockInQty;
            // totalstout += item.StockOutQty;
            totalrpl += item.StockJournalQty; // here im using the stockjoueral data 
            totalcls += item.ClosingQty;
            totalstkval += item.StockValue;
            totalsalval += item.SaleValue;
        });
        setTotalopbal(totalopbal);
        setTotalp(totalp);
        setTotalprtn(totalprtn);
        setTotals(totals);
        setTotalsrtn(totalsrtn);
        setTotalsint(totalstin);
        // setTotalstout(totalstout);
        setTotalrpl(totalrpl);
        setTotalcls(totalcls);
        setTotalstkval(totalstkval);
        setTotalsalval(totalsalval);
    }, [dataItem]);

    const fetchCustomerData = () => {

    };

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };

    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        setFromDate(selectedDate);
    };

    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        setToDate(selectedDate);
    };
    // Function to fetch item options based on input value
    const [itemsOptions, setItemsrOptions] = useState([]);
    const [selectedItemOption, setSelectedItemOption] = useState(null);

    const handleItemChange = (newValue) => newValue;
    const handleCateoryChange = (newValue) => newValue;
    const fetchItemOptions = async (inputValue = '') => {
        // Early return if input value is empty or too short
        if (!inputValue || inputValue.length <= 1) {
            return [];
        }

        try {
            // Fetch data from the API           
            const response = await fetchData('PurchaseApi', `/Item/${companyId}/${inputValue}`, token);
            // Check if the response code is 1111
            if (response.responseCode === '1111') {
                const data = await response.response_data;

                // Ensure the response data is an array
                if (Array.isArray(data)) {
                    setItemsrOptions(data); // Save the options for later use
                    return data.map(item => ({
                        value: item.Id,
                        label: item.ItemName1,
                    }));
                } else {
                    console.error('Data is not an array:', data);
                    return [];
                }
            } else {
                console.error('Unexpected response code:', response.responseCode);
                return [];
            }
        } catch (error) {
            console.error('Error fetching item options:', error);
            return [];
        }
    };
    // Function to fetch category options based on input value
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [selectedCategoryOption, setSelectedCategoryOption] = useState(null);
    const fetchCategoryOptions = async (inputValue = '') => {
        // Early return if input value is empty or too short
        if (!inputValue || inputValue.length <= 1) {
            return [];
        }
        try {
            // Fetch data from the API
            const response = await fetchData('PurchaseApi', `/Category/${companyId}/${inputValue}`, token);
            // Check if the response code is 1111
            if (response.responseCode === '1111') {
                const data = await response.response_data;
                // Ensure the response data is an array
                if (Array.isArray(data)) {
                    setCategoryOptions(data); // Save the options for later use
                    return data.map(item => ({
                        value: item.Id,
                        label: item.Name,
                    }));
                } else {
                    console.error('Data is not an array:', data);
                    return [];
                }
            } else {
                console.error('Unexpected response code:', response.responseCode);
                return [];
            }
        } catch (error) {
            console.error('Error fetching category options:', error);
            return [];
        }
    };

    const [ItemId, setItem] = useState('0');
    const handleChangeDrop = (selectedOption) => {
        setSelectedItemOption(selectedOption);
        const ItemId = selectedOption?.value || '0';
        setItem(ItemId);
        setDataItem([]);
    };

    const [CategoryId, setCategory] = useState('0');
    const handleChangeCategoryDrop = (selectedOption) => {
        setSelectedCategoryOption(selectedOption);
        const CategoryId = selectedOption?.value || '0';
        setCategory(CategoryId);
        setDataItem([]);
    };

    const hasReadReportPermission = permissions.includes('Read Reports');
    const [loading, setLoading] = useState(false);

    const fetchTableData = async () => {
        if (hasReadReportPermission) {
            setDataItem([]);
            setLoading(true);
            const branchId = 0;
            try {
                const response = await fetchData('ReportApi', `/Stock/Stock/stk/${companyId}/${ItemId}/${CategoryId}/${fromDate}/${toDate}`, token);
                if (response.responseCode === '1111') {
                    setDataItem(response.response_data);
                }
            } catch (error) {
                console.error('Error fetching Stock Details:', error);
            }
            finally {
                setLoading(false); // Hide loading screen
            }
        }
    };

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredDataItem = dataItem.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };

    const handleExportExcel = () => {

        const wb = XLSX.utils.book_new();
        // Get the current date and time
        const now = new Date();
        const formattedDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;


        // Create a sheet with all data (without grouping)
        const allDataSheet = [];
        // const allDataHeaderCaption = [`Stock From : ${formatDate(fromDate)} To : ${formatDate(toDate)}`];
        // allDataSheet.push(allDataHeaderCaption);
        const allDataHeaderCaption = [
            `Stock From: ${formatDate(fromDate)} To: ${formatDate(toDate)} | Generated On: ${formattedDateTime} By : ${username} `
        ];
        allDataSheet.push(allDataHeaderCaption);

        const headerRow = ['Category', 'Code', 'Item', 'Opening', 'Purchase', 'Purchase Return', 'Sale', 'Sale Return', 'Stock Journal Qty', 'Closing', 'Purchase Rate', 'MRP', 'GST%', 'HSN Code'];
        //   'Stock Journal',
        allDataSheet.push(headerRow);


        filteredDataItem.forEach((rowData) => {
            const dataRow = [
                rowData.CategoryName,
                rowData.Code,
                rowData.Name,
                rowData.OpeningQty,
                rowData.PurchaseQty,
                rowData.PurchaseReturnQty,
                rowData.SaleQty,
                rowData.SaleReturnQty,
                rowData.StockJournalQty,
                rowData.ClosingQty,
                parseFloat(rowData.PurchaseRate.toFixed(2)),
                parseFloat(rowData.MRP.toFixed(2)),
                rowData.GSTRate,
                rowData.HSNCode,
            ];
            allDataSheet.push(dataRow);
        });


        // Add total row for the all data sheet
        const totalRowAll = ['Total', '', '', '', totalp, totalprtn, totals, totalsrtn, totalrpl];
        allDataSheet.push(totalRowAll);

        const allDataWs = XLSX.utils.aoa_to_sheet(allDataSheet);
        XLSX.utils.book_append_sheet(wb, allDataWs, 'Stock');


        // Write the workbook to a file
        XLSX.writeFile(wb, 'Stock.xlsx');
    };

    return (

        <div className="w-full  mx-auto" style={{ width: '100%', marginTop: '10px' }}>
            <h6 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black', fontWeight: 'bolder' }}>
                CONSOLIDATED STOCK
            </h6>
            <div style={{ width: '100%', marginBottom: '2', display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }}>

                <div className='w-full mb-2 flex' style={{ marginTop: '10px' }}>
                    {loading && (
                        <div style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            zIndex: 9999
                        }}>
                            <div>
                                <CircularProgress style={{ color: 'white' }} />
                                <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                            </div>
                        </div>
                    )}

                    <div className="w-4/5 mr-2 flex items-center" style={{ marginTop: '0.75%' }}>
                        <label
                            className="block uppercase tracking-wide text-black text-xs font-bold mr-2"
                            htmlFor="Weightage"
                        >
                            Category Name
                        </label>
                        <AsyncSelect
                            cacheOptions
                            loadOptions={fetchCategoryOptions}
                            onInputChange={handleCateoryChange}
                            onChange={handleChangeCategoryDrop}
                            value={selectedCategoryOption}
                            className="flex-grow"
                            styles={{
                                menu: (provided) => ({
                                    ...provided,
                                    zIndex: 1301,
                                }),
                                control: (provided) => ({
                                    ...provided,
                                }),
                            }}
                        />
                    </div>

                    <div className="w-4/5 mr-2 flex items-center" style={{ marginTop: '0.75%' }}>
                        <label
                            className="block uppercase tracking-wide text-black text-xs font-bold mr-2"
                            htmlFor="Weightage"
                        >
                            Item Name
                        </label>
                        <AsyncSelect
                            cacheOptions
                            loadOptions={fetchItemOptions}
                            onInputChange={handleItemChange}
                            onChange={handleChangeDrop}
                            value={setCategoryOptions}
                            className="flex-grow"
                            styles={{
                                menu: (provided) => ({
                                    ...provided,
                                    zIndex: 1301,
                                }),
                                control: (provided) => ({
                                    ...provided,
                                }),
                            }}
                        />
                    </div>

                    <Button
                        style={{
                            background: 'linear-gradient(to right, #C7FFD8,#C7FFD8)',
                            borderRadius: '50px',
                            padding: '10px 20px',
                            color: '#0F0F0F',
                            fontWeight: 'bolder',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '35px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginLeft: '15px',
                            marginTop: '15px'
                        }}
                        onClick={fetchTableData}
                        className="linkcolor"
                    >
                        <span>Refresh</span>
                    </Button>

                    <Button
                        style={{
                            background: 'linear-gradient(to right, #98DED9,#98DED9)',
                            borderRadius: '50px',
                            padding: '10px 20px',
                            color: '#0F0F0F',
                            fontWeight: 'bolder',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '35px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginLeft: '10px',
                            marginTop: '15px'
                        }}
                        onClick={handleExportExcel}
                        className="linkcolor"
                    >
                        <span>Excel</span>
                    </Button>

                </div>
                <div className="watermark">
                    <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                </div>

                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        From Date
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={fromDate} onChange={handleFromDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        To Date
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={toDate} onChange={handleToDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
            </div>

            <div
                className="w-full mb-5 flex"
                style={{ maxHeight: '550px', overflowY: 'auto', marginTop: '7px' }}
            >
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#08396B', width: '2500px' }}>
                            <TableRow sx={{ whiteSpace: 'nowrap', textTransform: 'uppercase' }}>
                                {[
                                    'Code',
                                    'Item',
                                    'Opening',
                                    'Purchase',
                                    'Purchase Return',
                                    'Sale',
                                    'Sale Return',
                                    'Stock Journal Qty',
                                    'Closing',
                                    'Re Order Level Qty',
                                    'Purchase Rate',
                                    'MRP',
                                    'GST%',
                                    'HSN Code',
                                    'Last Sale Date',
                                    'Last Sale Qty'
                                ].map((header) => (
                                    <TableCell
                                        key={header}
                                        sx={{
                                            borderBottom: '1px solid #F5F5F5',
                                            fontWeight: 'bolder',
                                            fontSize: '11px',
                                            padding: '5px',
                                            color: 'whitesmoke',
                                            backgroundColor: '#08396B'
                                        }}
                                    >
                                        {header}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>

                        <TableBody sx={{ backgroundColor: 'whitesmoke' }}>
                            {Object.entries(
                                filteredDataItem.reduce((acc, item) => {
                                    if (!acc[item.CategoryName]) acc[item.CategoryName] = [];
                                    acc[item.CategoryName].push(item);
                                    return acc;
                                }, {})
                            ).map(([category, items]) => (
                                <React.Fragment key={category}>
                                    {/* Category header row */}
                                    <TableRow sx={{ backgroundColor: '#f0f0f0' }}>
                                        <TableCell
                                            colSpan={16}
                                            sx={{
                                                borderBottom: '1px solid black',
                                                color: '#183B4E',
                                                fontWeight: 'bold',
                                                fontSize: '13px',
                                                padding: '8px',
                                                backgroundColor: '#e0e0e0',
                                            }}
                                        >
                                            {category}
                                        </TableCell>
                                    </TableRow>

                                    {items.map((data, index) => (
                                        < TableRow
                                            key={data.id}
                                            className="highlighted-row"
                                            sx={{
                                                padding: '7px',
                                                backgroundColor: (() => {
                                                    if (data.ClosingQty < data.ReOrderLevelQty) return '#FFCFCF'; // Red
                                                    if (data.ClosingQty === data.ReOrderLevelQty) return '#E7FBB4'; // Yellow
                                                    if (data.ClosingQty - data.ReOrderLevelQty <= 5) return '#C9E6F0'; // Blue
                                                    return 'transparent'; // Default
                                                })(),
                                                ":hover": {
                                                    backgroundColor: '#D5E5D5',
                                                    cursor: 'pointer',
                                                },
                                            }}
                                        >

                                            {[
                                                data.Code, data.Name, data.OpeningQty, data.PurchaseQty, data.PurchaseReturnQty,
                                                data.SaleQty, data.SaleReturnQty, data.StockJournalQty, data.ClosingQty, data.ReOrderLevelQty,
                                                (data.PurchaseRate ?? 0).toFixed(2), (data.MRP ?? 0).toFixed(2), data.GSTRate,
                                                data.HSNCode, data.LastSaleDate, data.LastSaleQty
                                            ].map((value, i) => (
                                                <TableCell
                                                    key={i}
                                                    sx={{
                                                        borderBottom: '1px solid black',
                                                        color: i === 8 ? 'red' : 'black', // 🔴 Make ClosingQty text red
                                                        fontWeight: 'bolder',
                                                        padding: '7px',
                                                        fontSize: '12px',
                                                        textAlign: i >= 3 ? 'center' : 'left',
                                                    }}
                                                >
                                                    {value}
                                                </TableCell>
                                            ))}


                                        </TableRow>
                                    ))}

                                </React.Fragment>
                            ))}

                            {/* Totals row */}
                            <TableRow sx={{ padding: '3px', height: '22px', backgroundColor: '#9ACBD0' }}>
                                <TableCell colSpan={2} />
                                <TableCell
                                    sx={{
                                        borderBottom: '1px solid #F5F5F5',
                                        color: 'black',
                                        fontWeight: 'bolder',
                                        padding: '3px',
                                        fontSize: '14px',
                                        textAlign: 'left',
                                    }}
                                >
                                    {totalopbal}
                                </TableCell>
                                {[totalp, totalprtn, totals, totalsrtn, totalrpl, totalcls].map((total, index) => (

                                    <TableCell
                                        key={index}
                                        sx={{
                                            borderBottom: '1px solid #F5F5F5',
                                            color: 'black',
                                            fontWeight: 'bolder',
                                            padding: '3px',
                                            fontSize: '14px',
                                            textAlign: 'center',
                                        }}
                                    >
                                        {total}
                                    </TableCell>
                                ))}
                                <TableCell colSpan={3} />
                                <TableCell colSpan={5} />
                            </TableRow>
                        </TableBody>


                    </Table>
                </TableContainer>

            </div>

        </div >
    );
}

export default Stock;
